const cn = {
  LAYOUT: {
    SEND: "送出",
    CORS: "连接到服务器失败，请稍后再试(CORS)",
    NEXT_PAGE: "下一页",
    PREV_PAGE: "上一页",
    ON: "开启",
    OFF: "关闭",
    TITLE: "标题",
    CONTENT: "內文",
    BUTTON: "按钮",
    OR: "或",
    DISMISS: "返回",
    BACK: "返回",
    REGION: "地区",
    COUNTRY: "国家",
    COUNTRYCOUNT: "国家数量",
    UPDATE: "最后更新时间",
    SEARCH_RESULTS: "搜索结果",
    DOWNLOAD: "下载",
    UNIT_PL: "人",
    UNIT_MIN: "分",
    UNIT_SEC: "秒",
    UNIT_Y: "年",
    UNIT_M: "月",
    OFFDAY: "休假",
    WORKDAY: "工作日",
    D_0: "星期日",
    D_1: "星期一",
    D_2: "星期二",
    D_3: "星期三",
    D_4: "星期四",
    D_5: "星期五",
    D_6: "星期六",
    LAST_WEEK: "最近一周",
    LAST_MONTH: "最近一个月",
    LAST_THREE_MONTHS: "最近三个月",
    SATRT_DATE: "开始日期",
    END_DATE: "结束日期",
    EMPTY_FILTER: "找不到资料，请尝试其他筛选条件。",
    EMPTY_ROOM: "请先选择列表中的聊天室",
    GET_NEW_MESSAGE: "您收到一条新信息。",
    GET_NEW_LINK: "您收到一个超链接。",
    GET_NEW_FILE: "您收到一个档案。",
    MSG_OFFLINE: "目前处于离线状态，若想继续作业，请重新连接到网络。",
    MSG_RECONNECT: "连接已恢复。",
    MSG_ONLOGOUT:
      "由于您已闲置过久，为保障您的资讯安全，系统已将您强制登出，请重新登入。",
    MSG_ONCLOSE: "聊天连接错误或中断，10 秒后尝试重新连接。",
    MSG_LOGIN_AGAIN: "请重新登入。",
    MSG_YOU: "您",
    MSG_RETRACT: "已收回信息",
    NEWMSG: "您有新信息",
    BEFORE_CHANGE_ROOM: "您还有未送出的信息，切换聊天室后将清除这些信息。",
    DWONLOAD_ERROR: "找不到档案。",
    DWONLOAD_ERROR401: "权限不足，请先登入。",
    CONNECTION_STATE: "连线状态",
    DISCONNECTED: "连线中断，请稍后尝试。",
    RECONNECTING: "正在重新连线。",
    ISTYPING: "正在输入",
    AGENTIDLE: "提醒，{roomName} 已超过 {min} 分钟未回应用户，请主动联系用户。",
    CONFIRM: "了解",
    TOTAL_ITMES: "共 {total} 项目",
    ATTACHMENT: "附件",
    NEW_VERSION: "新版",
    OLD_VERSION: "舊版",
  },
  RULE: {
    FORMATE_ERROR: "格式錯誤",
    REQUIRED: "必填",
    PASSWORD: "请输入密码",
    PASSWORD_AGAIN: "请再次输入密码",
    PASSWORD_CONFIRM: "两次输入的密码不一致!",
    PASSWORD_LEN: "长度在 6 到 12 位",
    CANNED_KEYWORD: "开头必须为「#」半形符号，限制2~10位",
    EMAIL_FORMATE: "请填入正确信箱格式",
    EMAIL_FORMATE2: "请输入有效的 ASUS 电子邮件",
    PASSWORD_RULE:
      "注意：长度限制15~20码，至少包含「数字」、「大写英文字母」、「小写英文字母」、「特殊符号」，其中三种。",
  },
  BUTTON: {
    LATER: "稍后",
    RESET: "重置",
    CANCEL: "取消",
    SAVE: "保存",
    CONFIRM: "确认",
    CREATE: "建立",
    SELECT: "选择",
    SEND: "送出",
    SETTING: "设定",
    EDIT: "编辑",
    VIEW: "查看",
    ADD: "新增",
    ACCEPT: "接受",
    REJECT: "拒绝",
    JOIN_ROOM: "已加入聊天室",
    UNJOIN_ROOM: "已拒绝加入聊天室",
    INVITE: "邀请",
    DELETE: "刪除",
    SEARCH: "搜索",
    MORE: "更多",
    NEXT: "下一步",
    PREV: "上一步",
    BACK: "返回",
    CHANGE: "修改",
    CHANGEPSW: "修改密码",
    EXPORT: "导出",
    SELECT_EXPORT: "选择导出",
    IMPORT: "导入",
    UPLOAD: "上传",
    UPDATE: "立即更新",
    PUBLISHED: "立即发布",
    SCHEDULE: "排程",
    ACTION: "操作",
    MANAGE: "管理",
    MONITOR: "监控",
    TRANSFER: "手动转接",
    AUTOTRANSFER: "自动转接",
    SELECTFILE: "选择文档",
    GSM_SEARCH: "GSM 查询",
    HISTORY_LOG: "查看对话记录",
    CUSTOMER_CREATE_EDIT_NOTE: "编辑/建立备注",
    BACK_LOGIN: "回登入页",
  },
  FORM: {
    TO: "至",
    STARTTIME: "开始时间",
    ENDTIME: "结束时间",
    STARTDATE: "开始日期",
    ENDDATE: "结束日期",
    OPT_PUBLISHED: "已发布",
    OPT_UNPUBLISHED: "未发布",
    OPT_RECALL: "已下架",
    OPT_EXPIRED: "已逾期",
    OPT_GENERAL: "一般公告",
    OPT_URGENT: "紧急公告",
    OPT_NONSERVICE: "非服务时间",
    OPT_EC_GENERAL: "电商-一般公告",
    OPT_EC_URGENT: "电商-紧急公告",
    OPT_EC_NONSERVICE: "电商-非服务时间",
    OPT_YES: "是",
    OPT_NO: "否",
  },
  MODULE: {
    LOADINGOPTIONS: "加载选项中...",
    SELECT_ALL: "全选",
    SELECT_REGION: "选择区域",
    SELECT_COUNTRY: "选择国家",
    SELECT_REGION_FIRST: "请先选择区域",
    SELECT_COUNTRY_FIRST: "请先选择国家",
    SELECT_SKILL: "选择技能",
    SELECT_AGENT: "选择专员",
    SELECT_STATUS: "选择状态",
    COUNTRY_NOASP: "此国家尚未建立服务商",
    COUNTRY_NOSKILL: "此国家尚未建立技能资料",
    SELECT_ASP: "选择服务商",
    SELECT_ASP_FIRST: "请先选择服务商",
    ASP_NOSKILL: "此服务商尚未新增技能资料",
  },
  NOTIFICATION: {
    STATUS_CHANGE_SUCCESS: "变更状态成功。",
    LOGIN_FAIL: "登入失败",
    LOGIN_EXPIRE: "密码过期，请重新设置。",
    LOGIN_SUCCESS: "欢迎回來 ",
    LOGOUT_SUCCESS: "登出成功",
    VERIFY_ERROR: "验证码输入错误",
    SYS: "系统",
    CONFIRM: "确定",
    CANCEL: "取消",
    LOGOUT: "登出",
    DELETE: "刪除",
    SUCCESS: "成功",
    ERROR: "错误",
    NOTICE: "提示",
    ALERT: "警告",
    NODATA: "找不到资料",
    SOMETHING_WENT_WRONG: "发生未知错误。",
    CREATE_SUCCESS: "资料已新增成功",
    SEND_SUCCESS: "资料已成功送出",
    UPDATE_SUCCESS: "资料已更新",
    SAVE_SUCCESS: "资料已成功保存",
    DELETE_SUCCESS: "资料已成功刪除",
    SCHEDULE_SUCCESS: "资料已排程成功",
    PUBLISH_SUCCESS: "资料已发布成功",
    SETTING_SUCCESS: "资料已设定成功",
    PASSWORD_CHANGE_SUCCESS: "密码已成功变更，下次登入请使用新密码。",
    SELECT_READY_AGENT: "请优先选择 Ready 状态的专员",
    CONFIRM_LOGOUT_1: "聊天正在进行中，您确定要登出嗎？",
    CONFIRM_LOGOUT_2: "确定要登出吗？",
    CONFIRM_DELETE: "确定要刪除吗？",
    CONFIRM_DELETE_SKILL: "确定要刪除此技能吗？",
    CONFIRM_DELETE_NOTES: "确定要刪除此备注吗？",
    CONFIRM_DELETE_ASP: "确定要刪除此服务商吗？",
    CONFIRM_DELETE_BULLETIN: "确定要刪除此公告吗？",
    CONFIRM_DELETE_COUNTRY: "确定要刪除此国家吗？",
    CONFIRM_DELETE_CANNED: "确定要刪除此罐头信息吗？",
    CONFIRM_PUBLISH: "确定要立即发布公告吗？",
    CONFIRM_SCHEDULE: "确定建立公告进入排程吗？",
    CONFIRM_CREATE_COUNTRY: "确定要新增此地区吗？",
    CONFIRM_CREATE_ASP: "确定要新增此服务商吗？",
    CONFIRM_CREATE_SKILL: "确定要新增此技能吗？",
    CONFIRM_CREATE_ACC: "确定要新增此账户吗？",
    CONFIRM_LEAVE_GROUP: "离开群组后你将无法收到该群组信息。",
    CONFIRM_LEAVE_GROUP_MSG: "确定离开此群组吗？",
    CONFIG_ANGENT_UNSEND: "此地区系统未允许专员撤回信息。",
  },
  NAV: {
    HOME: "首页",
    CHAT: "聊天室",
    HISTORY: "对话记录",
    CHATCASE: "对话案件",
    REPORT: "报告",
    ACD_MONITOR: "ACD 监控",
    DASHBOARD: "仪表板",
    SETTING: "设定",
    NOTIFY: "通知",
  },
  LOGIN: {
    EMAIL: "邮箱",
    PSW: "密码",
    REMEMBER: "记住我",
    LOGIN: "登入",
    FORGET_PSW: "忘记密码",
    ENTER_EMAIL: "请输入您的电子邮箱",
    ENTER_PSW: "请输入新密码",
    ENTER_PSW2: "请再次输入新密码",
    RESET_SUCCESS: "密码重设成功",
    RESET_SUCCESS_INFO: "请使用新密码登入",
    ENTER_VALIDATE_CODE: "请输入验证码(不分大小写)",
    SENT_1: "重置密码链接，已发送至您的邮箱",
    SENT_2: "已发送邮件至",
    SENT_3:
      "请前往查看您的邮箱，若邮件未出现在收件箱，请尝试到垃圾邮件中查看。(您可以关闭此页面)",
    ENTER_CODE: "输入验证码",
    CODE_SENT: "验证信已寄出",
    RESENT: "重新发送",
    VERIFY_FAIL: "验证失败",
  },
  HOME: {
    SERVICE_SKILL: "您的服务技能",
    ORDER_RATE: "建单率",
    WORK_ASSIGNMENT: "今日时间分配",
    CHART_WORK: "工作",
    CHART_BREAK: "休息",
    PICKUP_RATE: "即时状态",
    TH_SKILL: "技能",
    TH_INLINE: "已进线人数",
    TH_ONLINE: "排队人数",
    TH_SERVICED: "已服务人数",
    TH_PICKUPRATE: "进线占比",
    SAT: "用戶对你的满意度",
    TH_SAT: "满意",
    TH_UNSAT: "不满意",
    CODE: "今日二次邮件验证码",
  },
  CHAT: {
    CL: {
      TITLE: "用户聊天室",
      MYCLIENT: "我的用户",
      IDLE: "结束",
      NO_CLIENT: "没有来自用户的通知",
      ISSERVICE: "开始值机",
      HEAD: {
        TRIGGER_SURVEY: "触发满意度调查",
        SURVEY_TEXT: "{agent} 已送出满意度调查",
        TRIGGER_IDLE: "触发闲置提醒",
        TRANSFER: "转接",
        FINISH: "终止与用户对话",
        BLACK: "提交黑名单",
        NOTE: "用户备忘录",
        COPY_BTN: "复制聊天内容",
      },
      FINISH: {
        TITLE: "结束对话",
        REASON: "结束对话原因",
        OTHER_REASON: "其他原因",
        REASON_1: "服务已完成",
        REASON_2: "客户无响应",
        REASON_3: "客户同意断开",
        REASON_4: "其他",
        REASON_5: "安排远端服务",
      },
      TRANSFER: {
        TITLE: "转接设定",
        REASON: "请选择转接原因",
        REASON_1: "用户指定",
        REASON_2: "错线(下一步选择产品线)",
        REASON_3: "重大客诉(转接Supervisor)",
        REASON_4: "用户需要Video Call协助",
        REASON_5: "其他",
        REASON_OTHER: "请填写其他原因",
        F_SKILL: "支援产品线",
        TH_AGENT: "专员名称",
        TH_SKILL: "产品线",
        TH_STATUS: "状态",
        SELECAGENT: "选择专员",
        NO_AGENT: "目前尚无可转接的专员。",
        SELECTED_AGENT: "已选择专员",
        UNSELECTED_AGENT: "请选择转交专员",
        CONFIRM_SELECTED_AGENT: "确认转接给",
        A_ING: "请稍候，正在自动转接",
        M_ING: "请稍候，正在转接给",
        A_SUCCESS: "系统已自动转接成功。",
        M_SUCCESS: "已成功转接给",
        AM_FAIL: "转接失败，请重新填写原因及指派转接专员",
      },
      NOTE: {
        TITLE: "关于此用戶备注",
        CREATE: "建立新备注",
        EDIT: "编辑备注",
        CREATE_NOTE: "限制100字节",
        TH_DATE: "日期",
        TH_AGENT: "专员",
        TH_CONTENT: "内容",
      },
      INFO: {
        TITLE: "聊天室资料",
        SUBTITLE_1: "用户资料",
        SUBTITLE_2: "询问产品",
        SUBTITLE_3: "历史资料",
        SUBTITLE_4: "用户备注",
        CU_AVATAR: "大头贴",
        CU_NAME: "称呼",
        CU_EMAIL: "电子邮箱",
        CU_ORDER_NO: "订单编号",
        CU_TEL: "联系方式",
        CU_TIME: "当地时间",
        CU_LOCAL: "位置",
        CU_DEVICE: "装置",
        CU_PLATFORM: "平台",
        PD_TYPE: "问题分类",
        PD_SKILL: "产品线",
        PD_SKILL_NUM: "产品型号",
        PD_ID: "序列号",
        PD_WARRANTY: "保修范围",
        PD_WARRANTYEND: "保修到期日",
        PD_WARRANTY_REMOTE: "保修服务(远程服务相关)",
        PD_REMOTE: "延保服务(远程服务相关)",
        PROBLEM_NOTE: "问题描述",
        HS_VIEWLOGS: "查看对话记录",
        HS_TODAYINLINE: "当日进线次数",
        HS_INLINE: "30天内总进线次数",
        HS_LAST_SKILL: "上次咨询产品线",
        HS_LAST_SKILL_NUM: "上次咨询型号",
        HS_MODEL_QUICKSEARCH: "快速搜索",
        HS_MODEL_EMPTY: "尚无对话记录",
        HS_MODEL_1DAY: "今日",
        HS_MODEL_3DAY: "三日",
        HS_MODEL_7DAY: "七日",
        EDIT_PRODUCT: "编辑产品资料",
        GSM_INFO: "GSM 资料",
        SN_LOCK:
          "(SN Locked) 此设备不适用于华硕维修申请，请联系原经销商办理报修。",
        STOLEN: "此产品已被标记为「失窃」。",
      },
    },
    IN: {
      TITLE: "內部聊天室",
      CREATE: {
        TITLE: "建立群组",
        ENTER_GROUPNAME: "请输入群组名称",
      },
      INFO: {
        TITLE: "聊天室资料",
        SUBTITLE_1: "群组名单",
        INVITE: "邀请专员",
      },
      F_SEARCHNAME: "搜索专员姓名",
      TH_NICKNAME: "昵称",
      TH_USERNAME: "使用者名称",
      TH_SKILL: "产品线",
      TH_STATUS: "状态",
      TH_UNSELECT: "请选择专员",
      TH_SELECTED: "已选择名单",
    },
    UPLOAD: {
      TITLE: "上传文档",
      DROG: "直接拖曳文档至此",
      FORMATE: "文档格式限制",
      SIZE: "最大尺寸",
      TH_NAME: "名称",
      TH_SIZE: "尺寸",
      TH_TYPE: "格式",
      SELECT_AT_LEAST_IMAGE: "请至少选择一张图片",
      SELECT_AT_LEAST_FILE: "请至少选择一个文档",
      NOT_SUPPORT: "不支援的档案格式，请选择其他档案！",
      FILE_LIMIT: "部分档案超过尺寸限制。最大限制 {size}MB",
    },
    LINK: {
      TITLE: "加入超链接",
      TEXT: "输入文字",
    },
    CANNED: {
      TITLE: "罐头讯息",
      NO_GROUP: "尚未建立群组",
      SELECT_GROUP: "选择群组",
      SELECT_GROUP_FIRST: "请先选择群组",
      NO_CATE: "尚未建立分类",
      SELECT_CATE: "分类",
      ENTER_KEYWORD: "输入关键字过虑",
      ENTER_SHORTCUT: "输入关键字搜索",
      ENTER_SHORTCUT_OR_GROUP: "请输入关键字或选择群组",
      NO_CANNED: "尚未建立罐头讯息",
    },
    CHATCASE: {
      PROBLEM: {
        COPY_KB: "复制及引用",
        COPY_SUCCESS: "KB 已存入剪贴簿",
        CLOSE: "关闭",
        SELECT: "引用",
      },
      CREATE_CHATCASE: {
        ALERT: "提示：尚未选择KB",
      },
    },
  },
  HISTORY: {
    TITLE: "聊天室历史记录",
    NAV_TITLE1: "用户对话记录",
    NAV_TITLE2: "內部对话记录",
    NAV_TITLE3: "聊天对话搜寻",
    NAV_TITLE4: "Video Call 用户记录",
    KEYWORDL: "关键字",
    TH_DATE: "日期",
    TH_STARTTIME: "开始时间",
    TH_CUST: "客户名称",
    TH_CUSTASUSACC: "ASUS 账号",
    TH_PRODUCT: "产品",
    TH_PHONE: "客户电话",
    TH_EMAIL: "客户电子邮箱",
    TH_SN: "序号",
    TH_SESSIONID: "对话ID",
    TH_ROOMID: "聊天室ID",
    TH_GROUPNAME: "群组名称",
    TH_CREATOR: "建立者",
    TH_AGENTNAME: "客服姓名",
    TH_AGENTEMAIL: "客服Email",
    TH_TALKTIME: "交谈时间(s)",
    COPY_BTN: "复制聊天內容",
    COPY_SUCCESS: "已将聊天室內容存入粘贴簿。",
    SELECT_TYPE: "请选择汇出档案格式。",
  },
  CHATCASE: {
    TITLE: "聊天案件(Beta)",
    TEMP: "暂存草稿，尚未储存",
    CREATE_CASE: "建立案件",
    EDIT_CASE: "编辑案件",
    DATE: "日期",
    COUNTRY: "国家",
    SKILL: "產品",
    CHAT_HISTORY: "对话纪录",
    SESSION_NO: "Session No.",
    AGENTNAME: "专员名称",
    LASTSAVETIME: "储存时间",
    SUBMITTIME: "提交时间",
    STATUS: "状态",
    CASE_STATUS: "案件状态",
    CASE_STATUS_NEW: "开启",
    CASE_STATUS_FINISHED: "关闭",
    CASE_STATUS_REQUIRED: "案件状态未填写",
    SPECIAL_FLAG_L2: "已咨询L2",
    ROOM_CHANGED: "聊天室已切换，建单资料已重新载入，请确认后再送出。",
    CASENO: "单号",
    CMSSERVER: "CSM Server",
    ACTION: "动作",
    DRAFT: "Draft",
    SUBMITTED: "Done",
    UNSUBMITTED: "未提交",
    EDIT: "编辑",
    BASIC_INFO: "基本资料",
    AGENT_NAME: "专员名称",
    CLIENT_NAME: "客户名称",
    PHONE: "电话号码",
    EMAIL: "电子邮箱",
    PRODUCT: "产品",
    PRODUCT_SN: "产品序号",
    RMANO: "RMANo",
    TOPIC: "Topic",
    PROBLEM: "问题",
    SOLUTION: "解決方案",
    OS: "OS",
    DATAREADY: "資料已帶入",
    BTN_DRAFT: "存为草稿",
    BTN_SEND: "送出",
    COPY_CASENO: "单号已存入剪贴簿",
    CASE_CREATED: "聊天案件已建立",
    SN_ERROR: "请输入正确的产品序号。",
    SN_ERROR2: "非正确序号，将以空值送出。",
    CATA_ERROR: "序号正确，请选择产品线 (STW failed)",
  },
  REPORT: {
    NAV: {
      TITLE: "报告",
      AGENTSATUS: "专员状态",
      AGENT_DAILYSATUS: "专员每日状态",
      AGENT_DAILYSATUS_CHART: "专员每日状态图表 (Beta)",
      AGENT_KPIOCCUPANCY: "专员 KPI 与占用率 (Beta)",
      CSAT: "满意度报告",
      OVERALL_AGENT_SATISFACTION: "专总体专员满意度报告 (Beta)",
      OVERALL_SKILL_SATISFACTION: "总体技能满意度报告 (Beta)",
      COST: "费用计算",
      COST_REPORT: "费用报告",
      VIDEO_COST_REPORT: "Video Call 费用报告",
      COST_HOURLY: "每小时进线数据统计",
      KPI: "KPI",
      KPI_REPORT: "KPI 报告",
      KPI_REPORT_SKILL: "KPI 技能视图",
      KPI_REPORT_HOURLY: "KPI 报告 (每小时)",
      KPI_REPORT_SKILL_HOURLY: "KPI 技能视图 (每小时)",
      AHT_REPORT: "AHT 报告",
      AHT_REPORT_SKILL: "AHT 技能视图",
    },
    TH_DATE: "日期",
    TH_AGENT: "专员名称",
    TH_CLIENT: "客户名称",
    TH_SKILL: "技能",
    TH_STARTTIME: "开始时间",
    TH_ENDTIME: "结束时间",
    TH_STATUS: "状态",
    TH_DURATION: "期间",
    TH_CHAT: "Chat",
    TH_CHATTIME: "[C] 对话时间(分)",
    TH_REAYTIME: "[R] 就绪时间(分)",
    TH_ACWTIME: "[ACW] ACW 时间(分)",
    TH_AUXTIME: "[AUX] AUX 时间(分)",
    TH_LOGINTIME: "[L] 登入时间(分) (R+C+ACW_AUX)",
    TH_TOTALCHAT: "[TC] 全部对话时间(分)",
    TH_OCCUPANCY: "占用 (C/L)",
    TH_CONCURRENCY: "Concurrency (TC/L)",
    TH_AHT: "AHT",
    TH_CSAT: "满意度",
    TH_CHANNEL: "平台",
    TH_WAITTIME: "等候时间(秒)",
    TH_CUSTOMEREMAIL: "用户电子邮箱",
    TH_CUSTOMERLOCATION: "用户所在地",
    TH_TALKTIME: "交谈时间",
    TH_USERTALK: "是否交谈",
    TH_COUNTRY: "国家",
    TH_ASP: "服务商",
    TH_CHATOFFERED: "已提供交谈服务",
    TH_CHATANS: "已回答",
    TH_ANSRATE: "回答率",
    TH_QTYABD: "QTY 放弃",
    TH_ABDRATE: "放弃率 %",
    TH_QUEUED: "排队",
    TH_MAX_TIMETOANS: "最大回复时间",
    TH_AVG_TIMETOANS: "平均回复时间",
    TH_MAX_TIMETOABD: "最大放弃时间",
    TH_AVG_TIMETOABD: "平均放弃时间",
    TH_AVG_CHATTIME: "平均交谈时间",
    TH_SKILLSLA: "技能 SLA",
    TH_SLA60S: "SLA 60 秒 %",
    TH_CHAT_RECONNECTS: "重连数",
    TH_CHAT_RECONNECTS_RATE: "重连百分比%",
    EXPORT_REGION: "导出ALL",
    OPT_SAT: "請選擇滿意度",
    OPT_SAT_ALL: "不限",
    OPT_SAT_SATISFIED: "滿意",
    OPT_SAT_DISSATISFIED: "不滿意",
  },
  ACD: {
    TITLE: "实时监控",
    AGENTSTATE: "专员状态",
    SERVICELEVEL: "服务等级",
    SUMMARY: "摘要",
    TH_HANDLETIME: "处理时间",
    TH_AGENT: "专员",
    TH_SKILL: "技能",
    TH_STATUS: "状态",
    TH_STATEDURATION: "状态持续时间",
    TH_CURRENTNUM: "目前人数",
    TH_MAXNUM: "最大可接人数",
    TH_PICKUPNUM: "累计已接人数",
    TH_IDLETIME: "闲置时间",
    TH_INCOMING: "进线人数",
    TH_ANS: "已回复",
    TH_ANSRATE: "回复率",
    TH_SLA: "SLA",
    TH_SLARATE: "SLA %",
    TH_QUEUED: "排队人数",
    TH_MAXWAITING: "最大等待时间",
    TH_DISCSAT_COUNT: "不满意",
    TH_CSAT_COUNT: "满意",
    TH_CSAT: "满意度",
    TH_AHT: "AHT",
    TH_CHATID: "聊天室ID",
    TH_PRODUCT: "产品",
    TH_CUSTOMERNAME: "用户名称",
    TH_STARTTIME: "开始时间",
    TH_DURATION: "持续时间",
    TH_LASTMESSAGETIME: "最后发信时间",
    TH_IDLE: "闲置",
    F_AGENTSETTING: "专员设定",
    F_AGENTID: "专员 ID",
    F_AGENT: "专员名称",
    F_SKILL: "支援产品线",
    F_SUPPORTNUM: "支援 Chat 数",
    D_USERCHATLIST: "即时聊天室列表",
    D_CHATROOMINFO: "聊天室资讯",
    D_NOCHAT: "目前没有正在进行的会话",
    D_PRODUCT: "产品",
    D_PRODUCT_SN: "产品SN",
    D_PROBLEMTYPE: "问题类型",
    D_C_NAME: "用户名称",
    D_C_PHONENUM: "联络电话",
    D_C_EMAIL: "电子邮箱",
    D_C_EMPTY: "空",
    D_C_NOTE: "用户问题描述",
    BTN_RESET_SKILL: "技能重置",
    RESET_CONFIRM1: "确定要重置所有专员的技能吗？",
    RESET_CONFIRM2: "确定要重置专员的技能吗？",
    RESET_SUCCESS: "专员技能已重设。",
    FORCE_LOGOUT: "強制登出",
    FORCE_SET_AGENT_LOGOUT: "将专员登出系统",
    FORCE_LOGOUT_CONFIRM: "确认要将此专员强制登出吗？",
    FORCE_LOGOUT_SUCCESS: "专员已被登出。",
    QUEUE_NOTICE1: "有用户进线排队",
    QUEUE_NOTICE2: "当前排队总人数",
  },
  DASHBOARD: {
    TITLE: "仪表盘",
    CLOSED_CASE: "已结束案件",
    INPROCESS_CASE: "处理中案件",
    AGENT_SATUS: "专员状态",
    SAT: "满意度統计",
    C_AGENT_OL: "专员断线",
    C_AGENT_OL_I: "说明(专员断线)",
    C_CLIENT_OL: "用户断线",
    C_CLIENT_OL_I: "说明(用戶断线)",
    C_TIMEOUT_OL: "系统超时断线",
    C_TIMEOUT_OL_I: "说明(系統超时断线)",
    C_OTHER_OL: "其它原因断线",
    C_OTHER_OL_I: "说明(其它原因断线)",
    C_AHT_MORE60: "离AHT还有一分钟以上",
    C_AHT_MORE60_I: "说明(离AHT还有一分钟以上)",
    C_AHT_IN60: "离AHT小于一分钟以內",
    C_AHT_IN60_I: "说明(离AHT小于一分钟以內)",
    C_AHT_OVER: "超过AHT",
    C_AHT_OVER_I: "说明(超过AHT)",
    C_A_READY: "就绪",
    C_A_READY_I: "说明(就绪)",
    C_A_ACW: "ACW",
    C_A_ACW_I: "说明(ACW)",
    C_A_BREAK: "AUX-休息",
    C_A_BREAK_I: "说明(AUX-休息)",
    C_A_MEETTING: "AUX-会议",
    C_A_MEETTING_I: "说明(AUX-会议)",
    C_SAT: "满意",
    C_SAT_I: "说明(满意)",
    C_UNSAT: "不满意",
    C_UNSAT_I: "说明(不满意)",
    C_NOSAT: "未进行满意度调查",
    C_NOSAT_I: "说明(未进行满意度调查)",
    TH_STATUS: "状态",
    TH_AGENTNAME: "专员",
    TH_CUSTOMER: "用户",
    TH_SAT: "满意",
    TH_UNSAT: "不满意",
    TH_HANDLETIME: "处理时间",
    TH_STARTTIME: "开始时间",
    TH_SURVEYTIME: "调查问卷时间",
    TH_SURVEYCODE: "问卷结果",
  },
  SETTING: {
    INDEX: {
      PERSONAL_SETTING: "个人设定",
      PERSONAL_EDIT_PROFILE: "编辑个人资料",
      PERSONAL_EDIT_CANNEDRESPONSE_SETTING: "个人罐头信息设定",
      PUBLIC_CANNEDRESPONSE_LIST: "公用罐头信息列表",
      CHAT_SETTING: "对话设定",
      CHAT_BASIC_SETTING: "基本设定",
      CHAT_SYSTEM_COPYWROTIN_SETTING: "系统文案设定",
      CHAT_CANNEDRESPONSE_SETTING: "公用罐头信息设定",
      CHAT_BULLETIN_SETTING: "站外公告设定",
      BULLETIN_SETTING: "站內公告",
      NOTIFY_SETTING: "通知设定",
      COUNTRY_SETTING: "国家设定",
      ASP_SETTING: "服务商设定",
      SKILL_SETTING: "技能设定",
      SKILL_COUNTRY_SETTING: "国家技能设定",
      SKILL_REGION_SETTING: "公共技能设定",
      SKILL_SCHEDULE_SETTING: "技能假期预排",
      ACCOUNT_SETTING: "账号设定",
      EC_LOGIN: "电商设定-会员登入开关",
      GPT_SETTING: "ChatBot",
    },
    PERSONAL: {
      PROFILE: {
        TITLE: "编辑个人资料",
        ACC_INFO: "账号资讯",
        ACC: "账号",
        EMAIL: "邮箱",
        USERNAME: "使用者名称",
        CURRENTPSW: "现在密码",
        NEWPSW: "新密码",
        NEWPSW2: "再次输入新密码",
        BASIC_SETTING: "基本设定",
        AVATAR: "大头贴",
        UPLOAD_AVATAR: "上传/更改大头贴",
        NAME: "姓名",
        FIRSTNAME: "名",
        LASTNAME: "姓",
        NICKNAME: "昵称",
        GENDER: "性別",
        MALE: "男",
        FEMALE: "女",
        LAN: "语系",
        KBLAN: "KB 偏好语系",
      },
    },
    CANNED: {
      PERSONAL_CANNED_SETTING: "个人罐头信息设定",
      EDIT_PERSONAL_CANNED: "编辑个人罐头信息",
      EDIT_PUBLIC_CANNED: "编辑公共罐头信息",
      CREATE_PERSONAL_CANNED: "建立个人罐头信息",
      CREATE_PUBLIC_CANNED: "建立公用罐头信息",
      EDIR_GROUP: "编輯自定义群组",
      CREATE_CANNED: "建立罐头信息",
      IMPORT_CANNED: "导入罐头信息",
      EXPORT_CANNED: "导出全部罐头信息",
      SELECT_FILE: "请选择文档",
      DOWNLOAD_SAMPLE: "下载示范文档",
      CREATE_GROUP: "建立群组",
      CREATE_CATE: "建立分类",
      EDIT_GROUP: "编辑群组",
      EDIT_CATE: "编辑分类",
      GROUP_NAME: "群组名称",
      CATE_NAME: "分类名称",
      SELECTED_FILE: "已选择文档",
      SELECT_GROUP: "选择群组",
      SELECT_GROUP_FIRST: "请先选择群组",
      SELECT_CATE: "选择分类",
      ENTER_SHORTCUTS: "输入关键字",
      TH_GROUP: "群组",
      TH_CATE: "分类",
      TH_SHORTCUTS: "关键字",
      TH_CONTENT: "信息內容",
      TH_CREATOR: "建立者",
      TH_ACTION: "动作",
      EMPTYTEXT: "尚未建立任何罐头信息",
      SHORTCUT_INFO:
        "要在对话期间使用罐头信息，请输入 # 和关键字。您也可以使用逗号分隔关键字，替同一段信息设定多个关键字。",
      NO_GROUP: "尚未建立群组",
      NO_CATE: "尚未建立分类",
      BEFORE_DELETE_CANNED: "确认刪除此罐头信息吗?",
      BEFORE_DELETE_CATE: "确认刪除分类吗?",
      BEFORE_DELETE_GROUP: "确认刪除群组吗?",
      PUBLIC_CANNED_SELECT_COUNTRY: "公用罐头信息设定 - 选择国家",
      PUBLIC_CANNED: "公用罐头信息",
      MANAGE_GROUP: "管理产品分类",
      AGENT_CANNED: "专员罐头信息",
      IDLE_QUICK: "快速回复",
    },
    CHAT: {
      BASIC: {
        CHATLIST_FILTER: "聊天室列表捞取优化",
        CHATLIST_FILTER_INTRO: "开启后，专员的聊天室列表改为载入所有未结束的聊天室、结束时间在设定的保留时间内的已结束聊天室，不再捞取当天全部聊天室。",
        SELECT_COUNTRY: "对话基本设定 - 选择国家",
        TITLE: "对话基本设定",
        TRANSFER: "文档传输",
        FILE_TYPE: "文档支持格式",
        IMAGE_TYPE: "图片支持格式",
        AGENT_SEND_FILE: "允许专员发送「文档」给用户",
        AGENT_SEND_IMAGE: "允许专员发送「图片」给用户",
        AGENT_FILE_LIMIT: "专员「文档」传输最大限制",
        AGENT_IMAGE_LIMIT: "专员「图片」传输最大限制",
        PIC_ENCRYPTED: "图片是否加密",
        CLIENT_SEND_FILE: "允许用户发送「文档」给专员",
        CLIENT_SEND_IMAGE: "允许用户发送「图片」给专员",
        CLIENT_FILE_LIMIT: "用户「文档」发送最大限制",
        CLIENT_IMAGE_LIMIT: "用户「图片」发送最大限制",
        AGENT_DELETE_MSG: "允许专员回收信息",
        AUTO_DAYLIGHT_SAVING: "自动调整日光节约时间",
        PICKUP_TIME: "缓冲时间(秒)",
        SHOW_SURVEY_RUIE1: "显示问卷条件(时间)(秒)",
        SHOW_SURVEY_RULE1_INTRO:
          "对话时间少于指定时间(秒)就代表用户只进线没有对话，不显示问卷调查。",
        SHOW_SURVEY_RUIE2: "显示问卷条件(信息)(条)",
        SHOW_SURVEY_RULE2_INTRO:
          "对话內容少于指定数量就代表用户只进线没有对话，不显示问卷调查。",
        SHOW_SURVEY_RUIE3: "显示问卷条件(信息)",
        SHOW_SURVEY_RULE3_INTRO: "若用户没有传送讯息，不显示问卷调查。",
        AGENT_IDLE_TIMEOUT: "闲置提醒",
        AGENT_IDLE_TIMEOUT_INTRO:
          "正在進行的聊天室，專員超過設定的時間未回覆客戶。",
        IS_AGENT_IDLE: "仅当客户端发送最后一条消息时才会触发空闲提醒。",
        VIDEOCALL_SETTING: "Video Call 设定",
        ISRMANO: "RMA No. 必填",
        URL_SETTING: "网址设定",
        OFFICIAL_URL: "官网网址设定",
        ACCOUNT_URL: "登入网址设定",
      },
      COPYRIGHT: {
        SELECT_COUNTRY: "系统文案设定 - 选择国家",
        TITLE_BEFORECHAT: "系统文案设定 - 对话前",
        TITLE_ONCHAT: "系统文案设定 - 聊天室內",
        TITLE_SAT: "系统文案设定 - 满意度",
        TITLE_EC_SAT: "系统文案设定 - 电商满意度设定",
        TITLE_VIDEOCALL: "系统文案设定 - Video Call 设定",
        TAB: {
          BEFORECHAT: "对话前宣告与公告事项",
          ONCHAT: "聊天室內介绍与转接",
          SAT: "满意度调查选项设定",
          EC_TITLE: "电商满意度设定",
          VIDEOCALL: "Video Call 设定",
        },
        BEFORECHAT: {
          COPYRIGHT: "隐私权公告",
          SAT_CONSENT: "满意度回访同意书",
          WELCOME: "欢迎语",
          BBY: "BBY宣告",
          NOSERVICE: "非服务时间",
          SERVICE: "服务时间公告",
          UNSERVICE: "暂停服务",
          BUSY: "专员忙线中",
          AGE_CHECK: "电商入口年龄审核",
          AGE_LIMIT: "年龄限制",
          NonServiceProduct: "非服务产品线",
        },
        SERVICE_TYPE: {
          TITLE: "服务类型设定",
          OPTION: "选项",
          SN: "SN 检核",
          SN_CHECK: "仅接受持有有效序号的用户进行服务。",
        },
        ONCHAT: {
          SELFINTRO: "专员自我介绍",
          SELFINTRO_INFO:
            "范例：您好！我是线上客服专员 {Agent_Name}，很高兴为您服务。请问有什么可以帮到您？",
          IDLE_NOTICE: "用户闲置预告",
          IDEL_NOTICE_TIME: "闲置时间(s)",
          IDEL_NOTICE_TIME_INTRO:
            "用户闲置超过系统所设定时间，显示闲置信息。（单位:秒）",
          IDLE_DISCONNECT: "用戶闲置断线",
          IDLE_DISCONNECT_TIME: "断线时间(s)",
          IDLE_DISCONNECT_TIME_INTRO:
            "用户断线超过系统所设定时间，显示断线信息。（单位:秒）",
          TRANSFER_AGENT: "转接自我介绍",
          TRANSFER_AGENT_INTRO:
            "范例：您好！我是负责 {Skill_Name} 的专员 {Agent_Name}，很高兴为您服务。请问有什么地方可以协助您？",
          BEFOREFINISH: "终止服务提示",
          AGENT_DISCONNECT: "专员主动断线",
          CHAT_EXPORT: "对话记录导出",
          BUTTON_1: "按钮1",
          BUTTON_2: "按钮2",
          BUTTON_PLACEHOLDER: "请输入按钮文字",
          FINISH_OPTION_1: "按钮功能：服务已完成，进行满意度调查",
          FINISH_OPTION_2: "按钮功能：联络线上客服",
          EXPORT_ALLOW: "是否开放下载",
          EXPORT_WELCOME_TEXT: "下载文件欢迎词",
          EXPORT_PRIVACY_BTN: "隐私权按钮设定",
          EXPORT_PRIVACY_LINK: "隐私权链接",
          EXPORT_TERMS_BTN: "使用条款按钮设定",
          EXPORT_TERMS_LINK: "使用条款链接",
          YOUTUBE_NOTE: "若连结留空，点击图标将跳转到全球 YouTube 频道：",
        },
        SAT: {
          ISSURVEY: "显示问卷",
          SATISFIED: "满意",
          UNSATISFIED: "不满意",
          PLACEHOLDER: "请输入原因",
          OPTION: "选项",
          OTHER: "其他",
          OTHER_INFO: "开启后，在用户端显示填写栏位",
        },
        VIDEOCALL: {
          COPYRIGHT: "隐私权宣告",
          SAT: "满意度选项设定",
          EMAIL: "Email 设定",
          CONTENT_EXAMPLE_1:
            "在发送给客户的邮件中会插入 QR Code 图像、以及带有连结的Click here图像。请将下面两个字串(包含符号 { } )放置在文案中:",
          CONTENT_EXAMPLE_2: "1. {qrcode_image} 放在想要显示 QR Code 的位置",
          CONTENT_EXAMPLE_3:
            "2. {qrcode_link} 放在要显示 'Click here' 的文字旁边",
        },
      },
      BULLETIN: {
        SELECT_COUNTRY: "公告设定 - 选择国家",
        TITLE_LIST: "公告设定",
        TITLE_CREATE: "建立公告",
        TITLE_EDIT: "编辑公告",
      },
    },
    BULLETIN: {
      SELECT_COUNTRY: "站內公告设定 - 选择国家",
      TITLE_LIST: "站內公告设定",
      TITLE_CREATE: "建立站內公告",
      TITLE_EDIT: "编辑站內公告",
      FORM_DATE: "公告建立日期",
      FORM_TO: "至",
      FORM_STARTDATE: "开始日期",
      FORM_ENDDATE: "结束日期",
      FORM_CATEGORY: "分类",
      FORM_CATE_GENERAL: "一般公告",
      FORM_CATE_EMERGENCY: "紧急公告",
      FORM_CATE_NONSERVICE: "非服务时间公告",
      FORM_STATUS: "状态",
      FORM_UNPUBLISHED: "未发布",
      FORM_PUBLISHED: "已发布",
      TH_DATE: "建立时间",
      TH_CONTENT: "內容",
      TH_CATEGORY: "分类",
      TH_COUNTRY: "国家",
      TH_STATUS: "状态",
      TH_STARTTIME: "排程开始时间",
      TH_ENDTIME: "排程结束时间",
      C_SELECT_COUNTRY: "选择国家",
      C_TARGET: "发布对象",
      C_TARGET_AGENT: "服务专员",
      C_TARGET_CLIENT: "用户端",
      C_CATEGORY: "信息分类",
      C_SKILLGROUP: "发送产品线",
      C_CONTENT: "发布內容",
      C_LINK: "连接网址",
      C_ISSCHED: "是否排程",
      C_ISSCHED_YES: "是",
      C_ISSCHED_NO: "否",
      C_SCHED_STARTTIME: "排程开始时间",
      C_SCHED_ENDTIME: "排程结束时间",
      E_STATUS: "是否下架",
      E_STATUS_ACTIVE: "是",
      E_STATUS_INACTIVE: "否",
    },
    NOTICE: {
      SELECT_COUNTRY: "通知设定 - 选择国家",
      SELECT_ASP: "通知设定 - 选择服务商",
      TITLE: "通知设定",
      SUBTITLE: "出发条件与选项设定",
      NOTICE_01: "排队人数",
      NOTICE_02: "休息时间过长",
      NOTICE_03: "ACW时间过长",
      NOTICE_04: "服务时间无专员上线",
      NOTICE_05: "专员登入/登出通知",
      NOTICE_06: "专员状态变更",
      NOTICE_07: "专员HT时间过长",
      NOTICE_08: "专员网络异常",
      NOTICE_09: "满意度不佳(DSAT)",
      NOTICE_10: "进线量异常检测 (Beta)",
      LABEL_ONOFF: "关闭/开启",
      LABEL_NOTICETARGET: "通知对象",
      LABEL_LINEUP: "当排队人数大于",
      LABEL_AUX: "专员转态为AUX",
      LABEL_ACW: "专员状态为ACW",
      LABEL_HT: "专员HT时间过长",
      LABEL_TRIGGER: "触发阈值",
    },
    COUNTRY: {
      TITLE: "国家列表",
      SELECT_COUNTRY: "选择国家",
      EDIT_COUNTRY: "编辑国家",
      COUNTRY_CODE: "国家代码",
      COUTNRY_NAME: "国家名称",
      REGION: "区域",
      TIMEZONE: "时区",
      DST: "日光节约时间",
      ADD_DST: "新增日光节约时间",
      LINK: "连接",
      COPY_LINK_SUCCESS: "连接已存入粘贴簿",
      IS_ASUSLOGIN: "前台客户是否需要会员登入",
      IS_MAILVERIFY: "Email二次验证",
    },
    ASP: {
      SELECT_COUNTRY: "服务商设定 - 选择国家",
      TITLE: "服务商列表",
      TH_COUNTRY: "国家代码",
      TH_ASPNAME: "服务商名称",
      TH_ASPSKILL: "技能",
      TH_ASPCOUNT: "服务商数量",
      TH_SUPPORT_COUNTRY: "支援国家",
      TH_ISACTIVE: "是否服务",
      TH_NOTE: "反灰处为跨国支援厂商",
      FORM_TITLE_CREATE: "新增服务商",
      FORM_TITLE_EDIT: "服务商管理",
      FORM_NAME: "服务商名称",
      FORM_ON: "开启服务",
      FORM_ON_TIPS: "开启后该厂商即可提供服务",
      FORM_ITEM: "服务项目",
      FORM_ITEM_TIPS: "服务商提供的服务技能",
      FORM_TRANSFER: "专员之间技能转接",
      FORM_TRANSFER_TIPS: "若开启代表隶属同一服务商之下的专员可以互相技能转接",
      FORM_TRANSFER_ASP: "可转接其它服务商",
      FORM_TRANSFER_ASP_TIPS: "转接至相同国家其它的服务商",
      FORM_TRNASFER_COUNTRY: "跨国支援服务商",
      FORM_TRNASFER_COUNTRY_TIPS: "支援同区域国家服务商服务，若无请留空",
    },
    SKILL: {
      COUNTRY: {
        SELECT_COUNTRY: "国家技能设定 - 选择国家",
        TITLE: "国家技能管理",
        TH_SINGLE_SERVICE: "單一營業時間",
        TH_SINGLE_SERVICE_INFO:
          "所有技能的服务时间将依照「单一营业时间」的设置",
        TH_SKILL_GLOBAL: "技能(Global)",
        TH_SKILL_TAG: "技能(TAG)",
        TH_SKILL_LOCAL: "当地技能名称",
        TH_HANDLETIME: "处理时间",
        TH_DAY: "星期",
        TH_TIME: "时段",
        TH_NOTE: "技能服务时段",
        FORM_TITLE_CREATE: "建立技能",
        FORM_TITLE_EDIT: "技能管理",
        FORM_SUBTITLE_1: "技能设定",
        FORM_SUBTITLE_2: "新增服务时间",
        FORM_SUBTITLE_3: "服务时段",
        FORM_SKILL: "技能",
        FORM_SKILL_STATUS: "技能状态",
        FORM_SKILL_DISPLAY: "显示",
        FORM_SKILL_HIDDEN: "隐藏",
        FORM_SKILL_LOCAL: "当地技能名称",
        FORM_HANDLETIME: "技能处理时间",
        FORM_PRODUCT: "产品线",
        FORM_SELECTDAY: "请选择日期",
        FORM_STARTTIME: "开始时间",
        FORM_ENDTIME: "结束时间",
        FORM_ADD: "加入时段",
        OFFDAY: "休假",
      },
      REGION: {
        TITLE: "公共技能设定",
        SKILL_GLOBAL: "技能(Global)",
        SKILL_TAG: "技能(TAG)",
      },
      SCHE: {
        SELECT_COUNTRY: "技能假期预排 - 选择国家",
        TITLE: "技能假期预排",
      },
    },
    ACC: {
      TITLE: "账号管理",
      TITLE_CREATE: "新增账号",
      TITLE_EDIT: "编辑账号",
      COUNTRY: "国家",
      USERNAME: "使用者名称",
      ROLE: "角色权限",
      ASP: "服务商",
      SKILL: "技能",
      WEBRTC: "Video Call Lite",
      EMAIL: "电子邮箱",
      IS_FAKE_EMAIL: "虚拟邮件",
      CHANGE_PSW: "更改密码",
      PSW: "密码",
      PSWCONFIRM: "确认密码",
      RANDOM_PSW: "产生随机密码并复制",
      STATUS: "账号状态",
      MAXSERVICECOUNT: "最大服务人数",
      ISSERVICE: "开始值机",
      ISSERVICE_TRANSFER_ONLY: "仅服务转接用户",
      MANUAL_TRANSFER_ONLY: "仅限人工转接",
      ACD_MONITOR: "ACD监控设定",
      USERNAME_INFO: "请输入至少6-20位英数混和字符",
      PASSWORD_INFO: "请留意密码格式",
      ACC_SETTING: "账户设定",
      BASIC_SETTING: "基本设定",
      AVATAR: "大头贴",
      UPLOAD_AVATAR: "上传/更改大头贴",
      NAME: "姓名",
      FIRSTNAME: "名",
      LASTNAME: "姓",
      NICKNAME: "昵称",
      GENDER: "性別",
      MALE: "男",
      FEMALE: "女",
    },
    SELECT_COUNTRY: {
      COUNTRYCODE: "国家代码",
      COUNTRYNAME: "国家名称",
    },
    EC_LOGIN: {
      TITLE: "电商设定-会员登入开关",
      DESC: "欲开启/关闭国家会员登入流程，可以通过操作执行，「开启」客户需登入才能与客服人员开启对话 「关闭」客户将不用登入会员。",
      TH_REGION: "区域",
      TH_COUNTRYNAME: "国家名称",
      TH_ACTION: "操作",
    },
    GPT: {
      SELECT_COUNTRY: "ChatBot设定 - 选择国家",
      TITLE: "ChatBot 基本设定",
      SYSTEM: {
        TITLE: "系统文案设定",
        PRIVACY: "隐私权宣告",
        SERVICE_TITLE: "营业/非营业时间公告",
        SERVICE: "营业时间公告",
        NON_SERVICE: "非营业时间公告",
        NON_SERVICE_REPLY: "非营业时间回复",
        NON_SERVICE_BTN: "按钮文字",
        NON_SERVICE_URL: "请输入URL",
        IDLE: "用户闲置",
        IDLE_LABEL: "闲置预告提醒(S)",
        IDLE_DESC: "用户闲置超过系统所设定时间，显示闲置讯息。（单位:秒）",
        OFFLINE: "用户断线",
        OFFLINE_MSG: "用户闲置断线讯息",
        OFFLINE_TIME: "断线时间(S)",
        OFFLINE_DESC: "用户闲置超过系统所设定时间，显示断线讯息。 （单位:秒）",
        SENTENCE: "对话次数限制",
        SENTENCE_MSG: "终止服务提示",
        SENTENCE_LABEL: "参数设定(次)",
        SENTENCE_DESC:
          "与BOT对话超过系统所指定的次数上限，显示终止服务讯息。 （单位:次)",
        IP_LIMIT_LABEL: "IP 每日 AI 回复次数上限(次)",
        IP_LIMIT_DESC:
          "同一 IP 每日调用 AI 回复超过指定次数，显示终止服务讯息，不影响 Decision Tree。（单位:次)",
        SAT: "用户不满意计数器",
        SAT_LABEL: "用户不满意计数器",
        SAT_DESC:
          "用户针对BOT的回覆，累计点选不喜欢到达指定的次数，显示转真人服务提示。 （单位:次)",
        SAT_SWITCH: "满意度调查",
        SAT_DISLIKE: "不满意原因",
        TOAGENT: "触发转真人服务",
        TOAGENT_MSG: "转真人服务提示",
        TOAGENT_LABEL: "次数设定(次)",
        TOAGENT_DESC: "显示转真人服务提示。 （单位:次)",
        AD: "广告设定",
        AD_URL: "请输入URL",
        AD_PIC: "上传新图片 (建议尺寸 330*120)",
        AD_NEW: "新增广告",
        BOT: "BOT对话设定",
        BOT_LABEL: "讯息文案",
        BOT_NEW: "新增文案",
        BOT_WELCOME: "欢迎文案",
        BOT_TEC: "技术支援回覆",
        BOT_PRODUCT: "产品线回覆",
        BOT_BOT: "BOT回覆结果",
        BOT_END: "结束聊天讯息",
        BOT_NOSERVICE: "非服務時間",
        BOT_REPAIR: {
          TITLE: "维修进度回复设置",
          INPUT: "SN/RMA No.输入提示文案",
          RECORD: "有维修记录",
          NORECORD: "无维修记录(未启用)",
          NOSN: "查无此序号",
          ERRORTIMES: "序号错误次数限制",
          TOAGENT: "转接客服文案",
        },
        BOT_WARRANTY: {
          TITLE: "保修状态回复设置",
          INPUT: "SN/RMA No.输入提示文案",
          RECORD: "有保修結果",
          NORECORD: "無保修結果(未启用)",
          NOSN: "查无此序号",
          ERRORTIMES: "序号错误次数限制",
          TOAGENT: "转接客服文案",
        },
      },
      BOT_NOSERVICE: "No-service Hour",
      DECISION_TREE: "Decision Tree 设定",
      TREE: {
        NORMAL: "一般",
        NAME: "名称",
        STYLE: "样式",
        OPTION: "操作",
        EDIT: "编辑",
        SORT: "排序",
        NEWLAYER: "新增阶层",
        EDITLAYER: "编辑阶层",
        KEYNAME: "意图",
        TITLE: "标题",
        SUBTITLE: "副标题",
        IS_SURVEY: "满意/不满意",
        DISPLAY: "显示",
        TOAGENT: "仅转真人服务",
        TOAGENT_DESC: "说明文案",
        TOAGENT_NONSERVICE: "非服务时间客制化回覆",
        LINK_STYLE: "连结样式设定",
        LINK: "连结设定",
        LINK_BTNTEX: "按钮文字",
        LINK_BLANK: "开启新窗口",
        CARD_STYLE: "卡片样式设定",
        CARD_IMAGE: "图片",
        CARD_BTNTEXT: "按钮文字",
        GPTLINK: "产品线",
        CHILD_LAYER_STYLE: "子层清单样式",
        CHILE_LAYER_OPT1: "文字",
        CHILE_LAYER_OPT2: "链接",
        CHILE_LAYER_OPT3: "链接(BOT)",
        CHILE_LAYER_OPT4: "卡片(链接)",
        CHILE_LAYER_OPT5: "卡片(BOT)",
        CHILD_LAYER_OPT_DESC: "※子层列表所呈现的样式(若有)",
        CHILD_LAYER_DESC: "子层清单说明",
        TUTORIAL: "引导页面",
        TUTORIAL_MODE: "引导模式",
        TUTORIAL_INTENT: "意图",
        TUTORIAL_TITLE: "标题",
        TUTORIAL_CONTENT: "描述",
        TUTORIAL_ICON: "图标",
        TUTORIAL_NEW: "新增引导",
      },
      SAT: {
        TITLE: "满意度调查选项设置",
      },
      SN_BLOCK: {
        TITLE: "SN Block List Setting",
      },
    },
  },
  NOTIFY: {
    ROLE: "权限",
    AREA: "地区",
    STATUS_SETTING: "状态设定",
    LOGIN: "登入/闲置",
    READY: "就绪",
    BREAK: "休息",
    LUNCH: "用餐",
    ACW: "文书作业",
    MEETING: "会议",
    COACHING: "培训",
    LOGOUT: "登出",
  },
  MESSAGECENTER: {
    TITLE: "通知中心",
    NO_MSG: "尚无任何通知",
    CHANGEPSW: "请于 {date} 前，变更新密码。",
    KB_LAG: "請完成KB偏好語系設定",
    FIRST_CHANGEPSW:
      "为了确保您的帐户安全，我们建议您定期变更密码。请问您是否希望现在就进行密码变更？点击「确认」来变更密码，或点击「稍后」以后再处理。",
  },
  VIDEO: {
    VIDEO_READY: "Video chat has already running.",
    CONFIRM: {
      TITLE: "Start a video  invitation(Beta)",
      TEXT: "Are you sure you want to send the video chat invitation?(Beta)",
      HANGUP: "Hangup",
      HANGUP_TEXT: "Are you sure you want to end the video chat?",
    },
    MESSAGE: {
      INVITE_MSG:
        'You have sent a video invitation to the customer. To cancel the invitation, please click "Cancel Video Invitation"',
      CANCEL_INVITE: "Cancel Video Invitation",
    },
    LAYOUT: {
      DEVICE_NOT_FOUND: "Webcam not found.",
      DEVICE_NOT_FOUND_INFO:
        "Your device was not detected, please make sure you have allowed the website to use your camera and microphone or if the device is already occupied by another application.",
      LOCAL_WEBCAM: "Your stream",
      DRAG: "Click here to drag the window",
      CLIENT_HANGUP: "Client has actively hung up the video connection",
      CLIENT_REFUSES: "The other party declined the video invitation",
    },
  },
  VIDEOCALL: {
    TITLE: "Video Call Lite (Beta)",
    READY: "准备好进行 Video Call",
    ENDED: "Video Call 已结束",
    WAITING: "等待用户端连线中...",
    IN_PROGRESS: "视频对话进行中",
    BACK_TO_CURRENT: "返回当前对话",
    RECORD_ING: "录影中",
    RECORD_PAUSE: "录影暂停",
    RECORD_END: "录影结束",
    CREATE: {
      SN_ERROR: "序号不存在",
    },
    CUSTOMER_ENDED: "用户已结束 Video Call",
    END: "关闭 Video Call",
    END_DESC:
      "是否关闭聊天室？按“确认”结束聊天室。（用户将无法再通过链接进入聊天室。）",
  },
  FUNNEL: {
    TITLE: "Funnel Chart (Beta)",
    ENTER_URL: "请输入网址",
    RESULT: "显示的网页",
  },
};
export default cn;
